import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import { Swatch, Swatches } from "../../../../src/gatsby-theme-docz/components/Swatch";
import { Table, TRow, TCol } from "../../../../src/gatsby-theme-docz/components/Table";
import * as React from 'react';
export default {
  Container,
  Row,
  Col,
  Spacer,
  Swatch,
  Swatches,
  Table,
  TRow,
  TCol,
  React
};